import { useReactiveVar } from '@apollo/client'
import { activeGlobalWindowsVar } from '../models/GlobalChatConversations'

export const useActiveGlobalWindowsVar = (): Array<string> => {
  return useReactiveVar(activeGlobalWindowsVar)
}
